import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ernq3ayb37: FaireBrandEntity = {
  token: "b_ernq3ayb37",
  type: "brand",
  name: "Yareli Wellness",
  avatarUrl:
    "https://cdn.faire.com/fastly/13644f378d2515e03b1f26bf6e4a53f4804db8504685415184f12c03bf3678c8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d4fa2854202235d65dc545a772ac28cbd9902857dd5238fe065ff6c88c188973.png",
  logoUrl:
    "https://cdn.faire.com/fastly/13644f378d2515e03b1f26bf6e4a53f4804db8504685415184f12c03bf3678c8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d4fa2854202235d65dc545a772ac28cbd9902857dd5238fe065ff6c88c188973.png",
  location: "Alpharetta, GA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "Yareli Bath & Beauty is dedicated to helping your customers feel their best with nature’s finest ingredients. Known for our signature Dead Sea magnesium flakes soaks, we specialize in products designed for recovery, relaxation, and healthier skin. Our formulas incorporate magnesium, one of the body's most crucial minerals, and other natural ingredients that promote smooth, hydrated, and rejuvenated skin.\n\nWith over 10,000 glowing reviews and features in Allure, Bustle, Daily Mail, and Well + Good, Yareli has become a trusted name in natural bath products. All products are free from parabens and meet strict European quality standards.\n\nWe’re proud to partner with charity: water in their mission to bring clean water to every person on the planet. This global organization builds sustainable, community-owned water projects, impacting 29 countries and serving over 18 million people. Yareli donates 10% of profits to charity: water to help bring lasting change to communities worldwide.\n\nFrom EWG Verified Epsom salt alternatives to therapeutic eucalyptus soaks and soothing oatmeal baths, Yareli offers simple, clean solutions that help retailers provide effective skin and body care options for their customers. Discover the benefits of magnesium bath soaks, foot soaks, and atopic dry skin treatments—pure, purposeful care your customers will love. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:47.260Z",
    importedBy: "entity-db-cli",
  },
};
